import React, { Component } from 'react';
/* eslint-disable */
import StarRatings from 'react-star-ratings';

import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import AppRoutes from '../../../config/AppRoutes';
import Loader from '../../../../common/loader';
import GMATCalculator from '../../../../common/Calculator/GMATCalculator';
import { renderHTMLContent } from '../../../../common/function';
var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

class GMAT2Statement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      question: '',
      explanation: '',
      choice_a: '',
      choice_b: '',
      answer1: '',
      answer2: '',
      user_answer1: '',
      user_answer2: '',
      offset: this.props.params.offset,
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      rating: 0,
      reportLoading: false,
      questionsArray: [],
      chapter_id: this.props.params.chapterid,
      reading_id: this.props.params.readingid,
      subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free',
      reading: this.props.params.reading,
      display_loader: 'show_block',
      questionHide: 'hide_block',
      option1: '',
      option2: '',
      option3: '',
      option4: '',
      option5: '',
      option6: '',
      error: '',
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      isQuestionValidated: false,
      save_text: `${language.LC().SAVE_QUESTION}`,
    };
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      reading_id: this.props.params.readingid,
      question_type: 'two_part_question',
      subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free',
    };
    let { offset } = this.state;
    FD.callAPI(
      App_data.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId',
      data,
    ).then(async resp => {
      if (resp.success) {
        this.setState({
          questionsArray: resp.result,
        });
        this.setQuestionData(resp.result, offset);
      }
    });
  }

  //Function to show Correct box and display right answer and store in database
  _getResult = async (item, e) => {
    // const { option1, option2, option3, option4, option5, option6 } = item;
    let {
      answer1,
      answer2,
      userValue1,
      userValue2,
      selectedChoiceNo,
      selectedChoiceYes,
      option1,
      option2,
      option3,
      option4,
      option5,
      option6,
    } = this.state;
    let expectedCount = 2;
    let count = 0;
    let optionArray = [];
    optionArray.push(option1);
    optionArray.push(option2);
    optionArray.push(option3);
    optionArray.push(option4);
    optionArray.push(option5);

    if (userValue1 && userValue2) {
      this.setState({
        error: '',
      });
      console.log('if');
    } else {
      // this.setRadioButtonBlank();
      this.setState({
        error: 'Please select all options ',
      });
      console.log('else');
    }

    if (option6) optionArray.push(option6);
    userValue2 = userValue2 ? userValue2.toLowerCase().trim() : null;
    answer2 = answer2 ? answer2.toLowerCase().trim() : null;
    if (userValue1 && userValue2) {
      if (userValue2 === answer2) {
        count++;
        this.setState({
          [selectedChoiceNo]: 'accent-success',
        });
      } else {
        optionArray.filter((item, index) => {
          if (item.toLowerCase().trim() === answer2) {
            let value = `choice${index + 1}_no`;
            this.setState(
              {
                [value]: 'accent-success',
              },
              () => {
                this.setRadioButtonSuccess(true);
              },
            );
            return;
          }
        });
        this.setState({
          [selectedChoiceNo]: 'accent-faliure',
        });
      }

      userValue1 = userValue1 ? userValue1.toLowerCase().trim() : null;
      answer1 = answer1 ? answer1.toLowerCase().trim() : null;
      if (userValue1 === answer1) {
        count++;
        this.setState({
          [selectedChoiceYes]: 'accent-success',
        });
      } else {
        optionArray.filter((item, index) => {
          if (item.toLowerCase().trim() === answer1) {
            let value = `choice${index + 1}_yes`;
            this.setState(
              {
                [value]: 'accent-success',
              },
              () => {
                this.setRadioButtonSuccess(true);
              },
            );
            return;
          }
        });
        this.setState({
          [selectedChoiceYes]: 'accent-faliure',
        });
      }

      // ========================================
      let right_answer = 0;
      if (expectedCount === count) {
        right_answer = 1;
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
          isQuestionValidated: true,
        });
      } else {
        this.setState({
          result_block: 'card show_block',
          result: 'INCORRECT',
          text_color: 'card-header text_failure',
          isQuestionValidated: true,
        });
      }
      // --------------- Save Stat API call Start -----------//
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: this.state.questionId,
        right_answer: right_answer,
        type: 'two_part_question',
        // time_done: this.state.count,
      };

      await FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(
        async resp => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              validated: true,
            });
          } else {
            this.setState({
              ValidToken: false,
            });
          }
          return resp;
        },
      );

      // --------------- Save Stat API call End-----------//
    }
  };

  getFavQuestions = questionid => {
    var params_fav = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      chapter_id: this.props.params.chapterid,
      type: 'two_part_question',
    };
    console.log('I am inside get Fav question', questionid);
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(
      response => {
        if (response.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      },
    );
  };

  getGMATRatting = questionid => {
    var params = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      type: 'two_part_question',
    };
    //Api to get ratting
    console.log('I am inside get Fav question', questionid);
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map(items =>
            this.setState({
              rating: items.ratting,
              ratting_text: 'Rated ',
            }),
          );
        }
      },
    );
  };
  setQuestionData = (questionsArray, offset) => {
    let questionObj = questionsArray[offset || 0];
    if (questionObj) {
      this.setState(
        {
          allQuestions: questionObj,
          question: questionObj.question,
          questionId: questionObj.id,
          choice_a: questionObj.choice_a,
          choice_b: questionObj.choice_b,
          explanation: questionObj.explanation,
          answer1: questionObj.answer1,
          answer2: questionObj.answer2,
          option1: questionObj.option1,
          option2: questionObj.option2,
          option3: questionObj.option3,
          option4: questionObj.option4,
          option5: questionObj.option5,
          option6: questionObj.option6,
          offset,
          questionHide: '',
          display_loader: 'hide_block',
          result_block: 'card hide_block',
          report_block: 'card hide_block',
          choice1_yes: '',
          choice1_no: '',
          choice2_yes: '',
          choice2_no: '',
          choice3_yes: '',
          choice3_no: '',
          choice4_yes: '',
          choice4_no: '',
          choice5_yes: '',
          choice5_no: '',
          choice6_yes: '',
          choice6_no: '',
        },
        () => {
          this.setRadioButtonBlank();
          this.getFavQuestions(questionObj.id);
          this.getGMATRatting(questionObj.id);
        },
      );
    }
  };
  //Function to fetch previous question
  _getPrevious = () => {
    let error;
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
      isQuestionValidated: false,
    });
    if (this.state.error) {
      this.setState({
        error: '',
      });
    } else {
      console.log('else', error);
    }
    if (this.state.userValue1) {
      this.setState({
        userValue1: '',
      });
    } else if (this.state.userValue2) {
      this.setState({
        userValue2: '',
      });
    } else {
      console.log('error');
    }

    document.getElementById('comment').value = '';
    let offset = parseFloat(this.state.offset) - 1;
    const { questionsArray, reading } = this.state;
    this.setQuestionData(questionsArray, offset);
    this.context.router.push({
      pathname: AppRoutes.GMAT_TWO_PART_STATEMENT.replace(':chapterid', this.state.chapter_id)
        .replace(':readingid', this.state.reading_id)
        .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
        .replace(':question_id', questionsArray[offset || 0].id)
        .replace(':offset', offset)
        .replace(':reading', reading),
    });
  };

  //Function to fetch Next question
  _getNext = () => {
    let error;
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
      isQuestionValidated: false,
    });
    if (this.state.error) {
      this.setState({
        error: '',
      });
    } else {
      console.log('else');
    }
    if (this.state.userValue1) {
      this.setState({
        userValue1: '',
      });
    } else if (this.state.userValue2) {
      this.setState({
        userValue2: '',
      });
    } else {
      console.log('error');
    }

    document.getElementById('comment').value = '';
    let offset = parseFloat(this.state.offset) + 1;
    const { questionsArray, reading } = this.state;
    this.setQuestionData(questionsArray, offset);
    this.context.router.push({
      pathname: AppRoutes.GMAT_TWO_PART_STATEMENT.replace(':chapterid', this.state.chapter_id)
        .replace(':readingid', this.state.reading_id)
        .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
        .replace(':question_id', questionsArray[offset || 0].id)
        .replace(':offset', offset)
        .replace(':reading', reading),
    });
  };

  setRadioButtonBlank = () => {
    for (let counter = 0; counter < 2; counter++) {
      let resetRadioButton = document.getElementsByName(`userValue${counter + 1}`);
      for (var i = 0; i < resetRadioButton.length; i++) resetRadioButton[i].checked = false;
    }
  };
  setRadioButtonSuccess = value => {
    let radioButtonElement = document.getElementsByName('accent-success_yes');
    for (var y = 0; y < 2; y++) {
      for (var i = 0; i < radioButtonElement.length; i++) radioButtonElement[i].checked = value;
      radioButtonElement = document.getElementsByName('accent-success_no');
    }
  };
  setRadioButtonAfterValidate = (event, choice1) => {
    this.setRadioButtonBlank();
    this.setRadioButtonSuccess(false);
    // let resetRadioButton = document.getElementsByName(name);
    // for (var i = 0; i < resetRadioButton.length; i++)
    //   resetRadioButton[i].checked = true;
  };
  //Function to Display Saved Question on button and save in database
  _saveQuestion = (item, e) => {
    // console.log("_saveQuestion");
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      type: 'two_part_question',
      topic_name: this.state.reading,
      reading_id: this.props.params.readingid,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          });
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
          });
          this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
          this.setState({ save_text: `${language.LC().Question_Saved}` });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  //Function to give star rattings
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue) {
      let params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/UpdateGMATRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1 });
            this.setState({ ratting_text: 'Rated ' });
          }
        },
      );
    }
    this.setState({ rating: nextValue });
    let params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items => {
              this.setState({ rating: items.ratting });
              this.setState({ ratting_text: `${language.LC().RATED}` });
            });
          } else {
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: this.state.questionId,
              ratting: nextValue,
              type: 'two_part_question',
            };
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
              response => {
                if (response.success) {
                  this.setState({ rated: 1 });
                  this.setState({ ratting_text: `${language.LC().RATED}` });
                }
              },
            );
          }
        } else {
          let params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: this.state.questionId,
            ratting: nextValue,
            type: 'two_part_question',
          };
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
            response => {
              if (response.success) {
                this.setState({ rated: 1 });
                this.setState({
                  ratting_text: `${language.LC().RATED}${nextValue} stars`,
                });
              }
            },
          );
        }
      },
    );
  }

  //Function to show Report box
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  //Funcion to save new report question
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      comment: comment,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
      type: 'two_part_question',
      topic_name: this.state.reading,
      reading_id: this.props.params.readingid,
    };
    // console.log(data);
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  //Function to redirect page to readings page
  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', this.props.params.chapterid),
    });
  };

  _getQuestions = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_LIST_QUE.replace(
        ':chapter_no',
        this.props.params.chapterid,
      )
        .replace(':id', this.props.params.readingid)
        .replace(':subscriptionstatus', this.state.subscriptionstatus)
        .replace(':reading', this.state.reading),
    });
  };

  //Function to show calculator
  _handleModal = () => {
    this.setState({
      show: true,
    });
  };

  onChangeValue(event, choice1) {
    const { name, value } = event.target;
    const { isQuestionValidated } = this.state;
    if (isQuestionValidated) {
      for (let i = 1; i <= 5; i++)
        this.setState({
          [`choice${i}_yes`]: '',
          [`choice${i}_no`]: '',
        });
      this.setState(
        {
          choice6_yes: '',
          choice6_no: '',
          userValue1: '',
          userValue2: '',
        },
        () => {
          this.setRadioButtonAfterValidate(event, choice1);
          let setRadioButton;
          // console.log(choice1);
          if (choice1.includes('_yes')) {
            setRadioButton = document.getElementsByName(`userValue1`);
          } else {
            setRadioButton = document.getElementsByName(`userValue2`);
          }
          setRadioButton[parseInt(choice1.match(/[0-9]/)[0]) - 1].checked = true;
        },
      );
    }
    if (choice1.includes('_yes'))
      this.setState({
        selectedChoiceYes: choice1,
      });
    else this.setState({ selectedChoiceNo: choice1 });
    for (let i = 1; i <= 6; i++)
      this.setState({
        [`choice${i}_yes`]: '',
        [`choice${i}_no`]: '',
      });
    this.setState({
      [name]: value,
      isQuestionValidated: false,
    });
  }
  render() {
    const {
      choice_a,
      choice_b,
      question,
      reportLoading,
      explanation,
      questionsArray,
      offset,
      reading,
      questionHide,
      display_loader,
      option1,
      option2,
      option3,
      option4,
      option5,
      option6,
      choice1_yes,
      choice1_no,

      choice2_yes,
      choice2_no,

      choice3_yes,
      choice3_no,

      choice4_yes,
      choice4_no,

      choice5_yes,
      choice5_no,

      choice6_yes,
      choice6_no,
      allQuestions,
      questionId,
      error,
    } = this.state;
    // console.log("error.................................",error)
    // let optionsArray = [];
    // for (const property in dataObject) {
    //   if (property.includes('option')) {
    //     optionsArray.push(dataObject[property]);
    //   }
    // }
    return (
      <div>
        {/* ----------- Header ---------------- */}
        <div className='margin_bottom_10 d-flex justify-content-between'>
          <div>
            <h1 className='section_head'>{language.LC().QUESTION_BANK}</h1>
          </div>
          <div>
            <button
              type='button'
              className='btn btn-primary pointer_class calc-btn'
              onClick={this._handleModal}
            >
              {language.LC().OPEN_CALCULATOR}
            </button>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getQuestions}
            >
              {language.LC().CHANGE_QUESTIONS}
            </button>

            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {language.LC().CHANGE_READING}
            </button>
          </div>
        </div>
        {/* ------------- Question ------------- */}
        <div className={`card margin_bottom_40 font-16px ${questionHide}`}>
          <div className='card-header'>
            <img
              src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
              className='margin_right_20'
              width='30'
              alt=''
            />
            {renderHTMLContent(reading, "span", "", { contentEditable: 'false' })}
            (
            {language.LC().Q} {questionId})
            <div className='float-right text-right'>
              {parseInt(offset) !== 0 ? (
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
              ) : null}
              {questionsArray.length - 1 !== parseInt(offset) ? (
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              ) : null}
            </div>
          </div>
          <div className='card-block'>
            {renderHTMLContent(question, "p")}
            <table
              className='text-center border-solid-1 margin_bottom_30'
            // border='1'
            >
              <tr>
                <th className='border-solid-1 p-10px'>{choice_a}</th>
                <th className='border-solid-1 p-10px'>{choice_b}</th>
                <th className='border-solid-1 p-10px' />
              </tr>
              {option1 ? (
                <tr>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice1_yes === 'accent-success' ? `${choice1_yes}_yes` : 'userValue1'}
                      value={option1}
                      onChange={e => this.onChangeValue(e, 'choice1_yes')}
                      className={`border-solid-1 cursor-pointer ${choice1_yes}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice1_no === 'accent-success' ? `${choice1_no}_no` : 'userValue2'}
                      onChange={e => this.onChangeValue(e, 'choice1_no')}
                      value={option1}
                      className={`border-solid-1 cursor-pointer ${choice1_no}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    {renderHTMLContent(option1, "span")}
                  </td>
                </tr>
              ) : null}
              {option2 ? (
                <tr>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice2_yes === 'accent-success' ? `${choice2_yes}_yes` : 'userValue1'}
                      value={option2}
                      onChange={e => this.onChangeValue(e, 'choice2_yes')}
                      className={`border-solid-1 cursor-pointer ${choice2_yes}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice2_no === 'accent-success' ? `${choice2_no}_no` : 'userValue2'}
                      value={option2}
                      onChange={e => this.onChangeValue(e, 'choice2_no')}
                      className={`border-solid-1 cursor-pointer ${choice2_no}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    {renderHTMLContent(option2, "span")}
                  </td>
                </tr>
              ) : null}
              {option3 ? (
                <tr>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice3_yes === 'accent-success' ? `${choice3_yes}_yes` : 'userValue1'}
                      value={option3}
                      onChange={e => this.onChangeValue(e, 'choice3_yes')}
                      className={`border-solid-1 cursor-pointer ${choice3_yes}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice3_no === 'accent-success' ? `${choice3_no}_no` : 'userValue2'}
                      value={option3}
                      onChange={e => this.onChangeValue(e, 'choice3_no')}
                      className={`border-solid-1 cursor-pointer ${choice3_no}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    {renderHTMLContent(option3, "span")}
                  </td>
                </tr>
              ) : null}
              {option4 ? (
                <tr>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice4_yes === 'accent-success' ? `${choice4_yes}_yes` : 'userValue1'}
                      value={option4}
                      onChange={e => this.onChangeValue(e, 'choice4_yes')}
                      className={`border-solid-1 cursor-pointer ${choice4_yes}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice4_no === 'accent-success' ? `${choice4_no}_no` : 'userValue2'}
                      value={option4}
                      onChange={e => this.onChangeValue(e, 'choice4_no')}
                      className={`border-solid-1 cursor-pointer ${choice4_no}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    {renderHTMLContent(option4, "span")}
                  </td>
                </tr>
              ) : null}
              {option5 ? (
                <tr>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice5_yes === 'accent-success' ? `${choice5_yes}_yes` : 'userValue1'}
                      onChange={e => this.onChangeValue(e, 'choice5_yes')}
                      value={option5}
                      className={`border-solid-1 cursor-pointer ${choice5_yes}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice5_no === 'accent-success' ? `${choice5_no}_no` : 'userValue2'}
                      onChange={e => this.onChangeValue(e, 'choice5_no')}
                      value={option5}
                      className={`border-solid-1 cursor-pointer ${choice5_no}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    {renderHTMLContent(option5, "span")}
                  </td>
                </tr>
              ) : null}
              {option6 ? (
                <tr>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice6_yes === 'accent-success' ? `${choice6_yes}_yes` : 'userValue1'}
                      onChange={e => this.onChangeValue(e, 'choice6_yes')}
                      value={option6}
                      className={`border-solid-1 cursor-pointer ${choice6_yes}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    <input
                      type='radio'
                      id='html'
                      name={choice6_no === 'accent-success' ? `${choice6_no}_no` : 'userValue2'}
                      onChange={e => this.onChangeValue(e, 'choice6_no')}
                      value={option6}
                      className={`border-solid-1 cursor-pointer ${choice6_no}`}
                    />
                  </td>
                  <td className='border-solid-1 p-10px'>
                    {renderHTMLContent(option6, "span")}
                  </td>
                </tr>
              ) : null}
            </table>
            <p className='error_msg'>{error}</p>
            <div className='row bottom-tool'>
              <ValidateSaveReportIcon
                isQue={true}
                _getResult={this._getResult}
                _saveQuestion={this._saveQuestion}
                _displayReportForm={this._displayReportForm}
                all_questions={allQuestions}
                save_text={this.state.save_text}
                bookmarkCSS={this.state.bookmarkCSS}
                bookmarkColor={this.state.bookmarkColor}
              // isSpecialQuestion={true}
              />
              <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                <div className='star_rating_wrap'>
                  <span className=' margin_bottom_0 margin_right_10'>
                    {this.state.ratting_text}
                  </span>
                  <StarRatings
                    rating={this.state.rating}
                    starRatedColor='rgb(255, 180, 0)'
                    starEmptyColor='rgb(51, 51, 51)'
                    starDimension='20px'
                    starHoverColor='rgb(255, 180, 0)'
                    starSpacing='2px'
                    changeRating={this.onStarClick.bind(this, question)}
                    numberOfStars={5}
                    name='rate1'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ----------- explanation section ---------- */}

        <div className={`${this.state.result_block} font-lusitana font-16px`}>
          <div className={this.state.text_color}>{this.state.result}</div>
          <div className='card-block'>
            {renderHTMLContent(
              explanation,
              "p",
              "view_questionhtml",
              { contentEditable: 'false' }
            )}
          </div>
        </div>
        {/* ----------- Report section  ---------------*/}
        <div className={this.state.report_block}>
          <div className='card-header'>{language.LC().REPORT}</div>

          {!this.state.successAlert ? (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().COMMENT}</strong>
                  </label>
                </div>
                <div className='col-sm-12 margin_bottom_10'>
                  <textarea
                    id='comment'
                    name='comment'
                    rows='6'
                    className='form-control'
                    placeholder='Content..'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class report-btn'
                    disabled={reportLoading}
                    onClick={this._reportQuestion.bind(this, question)}
                  >
                    {' '}
                    {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                  </button>
                  <button
                    type='button'
                    className='btn btn-danger active pointer_class margin_left_10'
                    onClick={this._hideReportForm.bind(this, question)}
                  >
                    {' '}
                    {language.LC().CANCEL}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12 report-Success-card'>
                  <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                  </label>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class  min-vw-120'
                    onClick={this.onClose}
                  >
                    {' '}
                    {language.LC().CLOSE}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* --------------- Loader -------------- */}
        {display_loader === 'show_block' ? <Loader /> : null}
        <GMATCalculator
          addToInput={this.addToInput}
          show={this.state.show}
          addDecimal={this.addDecimal}
          addZeroToInput={this.addZeroToInput}
          clearInput={this.clearInput}
          add={this.add}
          subtract={this.subtract}
          multiply={this.multiply}
          divide={this.divide}
          evaluate={this.evaluate}
          closeModal={() => this.setState({ show: false })}
        />
      </div>
    );
  }
}
export default GMAT2Statement;



// WEBPACK FOOTER //
// ./src/views/GMAT/QuestionBank/SpecialQuestions/GMAT2Statement.js